// 내부수정: 날짜 일괄 수정
import {useMutation} from "@tanstack/react-query";
import {useModal} from "../../../../hooks";
import {AxiosError} from "axios";
import {updateIssueDateBulk} from "../../../../api/order/TaxInvoiceApi";

export const useUpdateTaxIssueDateBulk = () => {
    const {handleModal} = useModal();
    const {mutateAsync} = useMutation({
        mutationFn: (data: { taxIds: number[], issueDate: string }) => updateIssueDateBulk(data),
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });
    return {mutateAsync};
};